import React from 'react';
import anomalyError from '../../../assets/SVGs/anomaly_error.svg';
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const SomethingWentWrong = (props) => {
	const useStyles = makeStyles(() => ({
		container: {
			marginTop: '5%',
		},
		imgContainer: {
			display: 'block',
			marginLeft: 'auto',
			marginRight: 'auto',
		},
		textContainer: {
			display: 'flex',
			justifyContent: 'center',
			fontFamily: 'Bogle-Regular',
			fontSize: '24px',
			fontWeight: '700',
			marginTop: '1%',
		},
        text2Container: {
			display: 'flex',
			justifyContent: 'center',
			fontFamily: 'Bogle-Regular',
			fontSize: '16px',
			color: '#74767C',
			marginTop: '1%',
		},
	}));

    const { highlightedText, text } = props;

	const classes = useStyles();

	return (
		<Box className={classes.container}>
			<img
				className={classes.imgContainer}
				src={anomalyError}
				alt="not-identified"
				width="100px"
				height="100px"
			/>

			<Box className={classes.textContainer}>
				{highlightedText}
			</Box>

            <Box className={classes.text2Container}>
				{text}
			</Box>

		</Box>
	);
};

SomethingWentWrong.defaultProps = {
	highlightedText: 'Something went wrong',
	text: 'Try reloading this page.'
};

SomethingWentWrong.propTypes = {
	highlightedText: PropTypes.string,
	text: PropTypes.string
};

export default SomethingWentWrong;
